export enum ActiveTabType {
  // OPTIONS,
  CHARACTERISTICS,
  LAYOUTS,
  DOCUMENTS,
  TRANSFORMER
}
